import Navbar from "./components/Navbar";
import FooterSection from "./components/FooterSection";

export default function NewFourLeadScoringPage() {
  return (
    <div className="min-h-screen bg-[#fff8ef] text-[#171717] overflow-hidden">
      <div className="fixed inset-0 pointer-events-none opacity-70" style={{ background: "radial-gradient(circle at 12% 18%, rgba(102,238,201,0.22), transparent 18%), radial-gradient(circle at 82% 14%, rgba(89,170,255,0.20), transparent 20%), radial-gradient(circle at 74% 68%, rgba(255,126,78,0.18), transparent 18%)" }} />
      <Navbar />
      <main className="relative z-10 pt-[110px] pb-20">
        <section className="pb-12 border-b border-[#171717]/8">
          <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-[0.95fr_1.05fr] gap-8 items-center">
            <div>
              <p className="text-[11px] uppercase tracking-[0.24em] text-[#6b6b6b] font-bold mb-4">Service • Lead Scoring</p>
              <h1 className="text-5xl md:text-6xl font-black tracking-[-0.06em] leading-[0.94] mb-5">Stop treating weak curiosity and serious demand like they mean the same thing.</h1>
              <p className="text-[#4f4f4f] text-lg leading-relaxed max-w-2xl mb-8">AI Lead Scoring helps teams see which visits matter, which sources produce real buying intent, and where attention is being wasted on noise.</p>
              <div className="flex flex-wrap gap-4">
                <button onClick={() => window.dispatchEvent(new Event("flowvory:open-strategy"))} className="px-7 py-4 rounded-full bg-[#171717] text-[#fff8ef] text-base font-bold shadow-[8px_8px_0_rgba(102,238,201,0.24)]">Book a Call</button>
                <div className="px-5 py-4 rounded-[22px] bg-white/80 border border-[#171717]/10 text-sm font-semibold">Built for teams that need cleaner prioritization across growth, sales, and remarketing.</div>
              </div>
            </div>
            <div className="rounded-[34px] border border-[#171717]/10 bg-[#171717] text-[#fff8ef] p-7 shadow-[0_30px_100px_rgba(23,23,23,0.08)]">
              <p className="text-[10px] uppercase tracking-[0.22em] text-white/45 font-bold mb-4">Where attention should go first</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  ["High intent / low volume", "Protect and prioritize", "bg-[#66eec9] text-[#171717]"],
                  ["High intent / high volume", "Scale and route", "bg-[#59aaff] text-[#171717]"],
                  ["Low intent / high volume", "Do not overreact", "bg-white/10 text-white"],
                  ["Low intent / low volume", "Minimal attention", "bg-white/10 text-white"],
                ].map(([title, text, cls], idx) => (
                  <div key={title} className={`rounded-[24px] p-5 border border-white/10 ${cls} ${idx === 1 ? "rotate-[-1deg]" : idx === 2 ? "rotate-[1deg]" : ""}`}>
                    <h3 className="text-lg font-black tracking-[-0.04em] mb-2">{title}</h3>
                    <p className="text-sm leading-relaxed opacity-80">{text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 border-b border-[#171717]/8">
          <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-[1.2fr_0.8fr] gap-6 items-start">
            <div className="grid sm:grid-cols-3 gap-4">
              {[
                ["Source quality", "Different channels create very different demand profiles."],
                ["Behavior depth", "Repeat visits, page paths, and offer interaction matter."],
                ["Routing logic", "The score matters only if the business acts on it differently."],
              ].map(([title, text], idx) => (
                <div key={title} className={`rounded-[26px] border border-[#171717]/10 p-5 shadow-[0_18px_50px_rgba(23,23,23,0.05)] ${idx === 1 ? "bg-[#dff3ff] rotate-[-1deg]" : idx === 2 ? "bg-[#fff0db] rotate-[1deg]" : "bg-white/86"}`}>
                  <h3 className="text-xl font-black mb-3 tracking-[-0.04em]">{title}</h3>
                  <p className="text-sm text-[#4f4f4f] leading-relaxed">{text}</p>
                </div>
              ))}
            </div>
            <div className="rounded-[30px] border border-[#171717]/10 bg-white/86 p-6 shadow-[0_18px_50px_rgba(23,23,23,0.05)]">
              <p className="text-[10px] uppercase tracking-[0.22em] text-[#6b6b6b] font-bold mb-3">Flowvory note</p>
              <blockquote className="text-2xl font-black tracking-[-0.04em] leading-snug mb-4">“The value of lead scoring is not in the score itself. It is in the better decisions the business makes because of it.”</blockquote>
              <p className="text-[#4f4f4f] text-sm leading-relaxed">Good scoring changes sales focus, remarketing logic, CRO priorities, and channel interpretation all at once.</p>
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
